import React, { useEffect, useState } from 'react'
import CommonSelect from '../../../core/common/commonSelect'
import { AppDispatch } from '../../../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllRoles } from '../../../core/data/redux/user/role/roleAction';
import { Drawer, message } from 'antd';
import { createPayscale, deletePayscale, fetchPayscales, updatePayscale } from '../../../core/data/redux/payroll/payrollComponent/payscale/payscaleActions';
import DeleteModal1 from '../../../core/modals/deleteModal1';
import { fetchingexperience } from '../../../core/data/redux/experience/experience.Action';
import { filterByStatus } from '../../../core/utils/filterActiveData';

const PayroleScaleModel: React.FC<any> = ({ handleCancel, isModalVisible, modalType, selectedRowData, payrollScaleData, setPayrollScaleData, setTableKey, setIsDeleteModalVisible, isDeleteModalVisible }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { roles } = useSelector((state: any) => state.role);
    const { user } = useSelector((state: any) => state.auth);
     const { loading } = useSelector((state: any) => state.payroll.payrollScall);
    const [errors, setErrors] = useState<any>({
        RoleId: '',
        SalaryRangeMin: '',
        SalaryRangeMax: '',
        ExperienceLevel: '',
    });
    const resetForm = () => {
        setPayrollScaleData({
            RoleId: '',
            SalaryRangeMin: '',
            SalaryRangeMax: '',
            ExperienceLevel: 'Junior',
        });
        setErrors({
            RoleId: '',
            SalaryRangeMin: '',
            SalaryRangeMax: '',
            ExperienceLevel: '',
        });
    };
    const [ experience,  setexperience] = useState([]);
     const activeExperience = filterByStatus(experience, 'active', 'Status');

    useEffect(() => {
        dispatch(fetchingexperience())
        .then((res) =>{
            setexperience(res.payload.data)
        })
      }, [dispatch]);

    useEffect(() => {
        if (roles.length === 0) {
            dispatch(fetchAllRoles())
        }
    }, [dispatch])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | any, field: string) => {
        const value = e.target ? e.target.value : e.value;
        setPayrollScaleData({
            ...payrollScaleData,
            [field]: value,
        });
        setErrors((prevErrors: any) => ({
            ...prevErrors,
            [field]: '',
        }));
    };

    const validateForm = () => {
        const errors: any = {};

        // Validate Role
        if (!payrollScaleData.RoleId) {
            errors.RoleId = 'Role is required';
        }

        // Validate Salary Range Min
        if (!payrollScaleData.SalaryRangeMin) {
            errors.SalaryRangeMin = 'Salary Range Min is required';
        } else if (isNaN(payrollScaleData.SalaryRangeMin) || payrollScaleData.SalaryRangeMin <= 0) {
            errors.SalaryRangeMin = 'Salary Range Min must be a number greater than 0';
        }

        // Validate Salary Range Max
        if (!payrollScaleData.SalaryRangeMax) {
            errors.SalaryRangeMax = 'Salary Range Max is required';
        } else if (isNaN(payrollScaleData.SalaryRangeMax) || payrollScaleData.SalaryRangeMax <= 0) {
            errors.SalaryRangeMax = 'Salary Range Max must be a number greater than 0';
        }

        // Validate Experience Level
        if (!payrollScaleData.ExperienceLevel) {
            errors.ExperienceLevel = 'Experience Level is required';
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        const updatedFormData = {
            ...payrollScaleData,
            CreatedBy: modalType === 'create' ? user.UserId : undefined,
            ModifiedBy: modalType === 'edit' ? user.UserId : undefined,
        };


        try {
            let result;
            if (modalType === 'create') {
                result = await dispatch(createPayscale(updatedFormData)).unwrap();
            } else if (modalType === 'edit') {
                if (selectedRowData) {
                    result = await dispatch(updatePayscale({ id: selectedRowData.Id, ...updatedFormData })).unwrap();
                }
            }
            if (result) {
                message.success(result.message);
                await dispatch(fetchPayscales());
                setTableKey((prevKey: any) => prevKey + 1);
                resetForm();
            } else {
                alert(result?.payload.error);
            }
            handleCancel();
        } catch (error) {
            message.error('An error occurred');
        }
    };

    const handleDeletePayScall = async (id: number) => {
        try {
            const result = await dispatch(deletePayscale(id));
            if (result.meta.requestStatus === 'fulfilled') {
                message.success(result.payload.message);
                await dispatch(fetchPayscales());
                setTableKey((prevKey: any) => prevKey + 1);
                setIsDeleteModalVisible(false);
            } else {
                message.warning(result.payload.error);
            }
        } catch (error) {
            message.error('Something went wrong');
        }
    };
    return (
        <>
            <Drawer
                title={modalType === "edit" ? "Edit Payscale" : "Add Payscale"}
                placement="right"
                width={600}
                onClose={() => {
                    handleCancel();  
                    resetForm();    
                }}
                visible={isModalVisible}
                style={{ marginTop: 50 }}
            >
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Role <span className="text-danger"> *</span></label>
                                    <select
                                        className="form-control"
                                        value={payrollScaleData.RoleId}
                                        onChange={(e) => handleInputChange(e, 'RoleId')}
                                    >
                                        <option value="">Select Role</option>
                                        {roles?.map((role: any) => (
                                            <option key={role.RoleId} value={role.RoleId}>
                                                {role.RoleName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.RoleId && <div className="text-danger">{errors.RoleId}</div>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Salary Range Min <span className="text-danger"> *</span></label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        step="0.01"
                                        value={payrollScaleData.SalaryRangeMin}
                                        onChange={(e) => handleInputChange(e, 'SalaryRangeMin')}
                                    />
                                    {errors.SalaryRangeMin && <div className="text-danger">{errors.SalaryRangeMin}</div>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Salary Range Max <span className="text-danger"> *</span></label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        step="0.01"
                                        value={payrollScaleData.SalaryRangeMax}
                                        onChange={(e) => handleInputChange(e, 'SalaryRangeMax')}
                                    />
                                    {errors.SalaryRangeMax && <div className="text-danger">{errors.SalaryRangeMax}</div>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Experience Level</label>
                                    <select
                                        className="form-control"
                                        value={payrollScaleData.ExperienceLevel}
                                        onChange={(e) => handleInputChange(e, 'ExperienceLevel')}
                                    >
                                        <option value="">Select Experience Level</option>
                                        {activeExperience?.map((exp: any) => (
                                            <option key={exp.value} value={exp.Id}>
                                                {exp.Label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.ExperienceLevel && <div className="text-danger">{errors.ExperienceLevel}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-white border me-2"
                            onClick={() => {
                                resetForm()
                                handleCancel()
                            }}
                        >
                            Cancel
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}    disabled={loading}  >
                              {loading && <span className="spinner-border spinner-border-sm me-2" />}
                            {modalType === 'edit' ? 'Update Payscale' : 'Add Payscale'}
                        </button>
                    </div>
                </form>
            </Drawer >
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() => selectedRowData?.Id && handleDeletePayScall(selectedRowData.Id)}
            />
        </>


    )
}

export default PayroleScaleModel